<template>
    <div>
        <div class="hint block">
            <p><i class="icon iconfont icon-tongzhi1 mr10 font-gold"></i><span>提示:最多上传{{dbCount}}个附件，上传附件大小不可超过30M</span></p>
        </div>
        <div class="form-value">
            <div class="simple-row">
                <div class="left">
                    <swb-file-upload fileGroup="image-goods" fileFor="large.files" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :onDone="onUploadDone" :multipleFile="true"></swb-file-upload>
                </div>
                <div class="right">
                    <button class="swb-btn swb-btn-small swb-btn-primary" @click="setAttTag($event)">批量设置标签</button>
                </div>
            </div>
            <ul class="file-area input clearfix" v-if="servcWorkImgList.length > 0">
                <li class="file-content clearfix" :class="{'active': servcWorkImg.checked}" v-for="(servcWorkImg, index) in servcWorkImgList">
                    <el-checkbox v-model="servcWorkImg.checked"></el-checkbox>
                    <swb-file-item :trackKey="index" :fileName="servcWorkImg.fileName" :fileUuid="servcWorkImg.fileUuid" :fileBrowseUrl="servcWorkImg.fileBrowseUrl" :fileDownloadUrl="servcWorkImg.fileDownLoadUrl"
                                   :fileMd5="servcWorkImg.fileMd5" :deletable="true" :onDelete="deleteFile"></swb-file-item>
                    <el-input :title="servcWorkImg.desc" @blur="changeDesc(index)" v-model="servcWorkImg.desc" placeholder="文件名称不可多于50个字"></el-input>
                    <div>{{servcWorkImg.ts}}</div>
                    <div class="mt5"><i v-if="servcWorkImg.tagName != null" class="swb-tags swb-tags-success mr5">{{servcWorkImg.tagName}}</i></div>
                    <div class="mt5">
                        <a class="swb-btn swb-btn-link" @click="setTag($event,index)">设置标签</a>
                        <a v-if="servcWorkImg.tagName != null" @click="removeCancel(index)" class="swb-btn swb-btn-link">移除标签</a>
                    </div>
                </li>
            </ul>
        </div>
        <swb-dt-popover ref="attPopoverRef" classes="popper-tabs">
            <swb-att-tag-list-for-select :attAspect="attAspect" :selectName="tagName" ref="swb_att_tag_list_for_select" @notity-attTag-comfirm="doAttTagConfirm" @notity-attTag-cancel="doAttTagCancel"></swb-att-tag-list-for-select>
        </swb-dt-popover>
    </div>
</template>
<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes, getComnMerchantAttTag} from '../../app.vues'
    //
    import servcDelivApi from '../../api/servcDeliv';
    //
    import SwbFileUpload from '../ctrl/FileUpload';
    Vue.regist(SwbFileUpload);
    import SwbFileItem from '../ctrl/FileItem';
    Vue.regist(SwbFileItem);
    import SwbAttTagListForSelect from '../attTag/AttTagListForSelect'
    Vue.regist(SwbAttTagListForSelect);
    let bizTagObj = null;
    export default {
        name: 'swb-servc-voucher-img-edit',
        desc: '工单信息上传',
        props: ["count"],
        data: function () {

            return {
                // 资产图片
                servcWorkImgList: [],
                attAspect: getEnumInfoWith('retailerAttAspect', 'name', 'WorkVoucher').value,
                selectTagId: null,
                bizTag: false,
                index: null,
                indexList: [],
                tagName: null,
                dbCount: 0,
            }
        },
        created: function () {
            bizTagObj = getComnMerchantAttTag();
            this.getMaxWorkAttachFileCount();
        },
        methods: {
            getMaxWorkAttachFileCount: function () {
                let self = this;
                servcDelivApi.getMaxWorkAttachFileCount({}, function (result) {
                    if (result.type == "info") {
                        self.dbCount = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            //上传前（进行验证检查）处理，可以返回false取消上传
            onBeforeUpload: function (fileItems, uploader) {
                let dbCount = this.dbCount;
                let count = this.count + this.servcWorkImgList.length;
                if (fileItems.length > 10) {
                    MsgBox.warning("一次最多上传10个附件");
                    return false;
                }
                if (fileItems.length > (dbCount - count)) {
                    MsgBox.warning("现在" + count + "个附件,最多还能再上传" + (dbCount - count) + "个附件");
                    return false;
                }
                if (count > (dbCount - 1)) {
                    MsgBox.warning("最多上传" + dbCount + "个附件");
                    return false;
                }

                if (fileItems.length === 0) {
                    MsgBox.warning('喂，你还没选择要上传的文件吧');
                    return false;
                }
            },
            //上传进度处理
            onProgress: function (progress) {
                let self = this;
                let percentage = Math.floor((progress.loaded / progress.total) * 100);
                Toast.show("正在上传" + percentage + "%", 3000);
            },
            //上传完毕处理（根据result.type判断是否有误）
            onUploadDone: function (result) {
                let self = this;
                let dbCount = self.dbCount;
                if (self.count > (dbCount - 1)) {
                    MsgBox.warning("最多上传" + dbCount + "个附件");
                    return false;
                }
                let servcWorkImgList = self.servcWorkImgList || [];
                if (result.type === 'info') {
                    let files = result.data.files || [];
                    for (let i = 0; i < files.length; i++) {
                        let file = files[i];
                        let servcWorkImg = {};
                        servcWorkImg.fileName = file.fileName;
                        servcWorkImg.fileUuid = file.fileUuid;
                        servcWorkImg.fileExtName = file.fileExtName;
                        servcWorkImg.fileBrowseUrl = file.fileBrowseUrl;
                        servcWorkImg.fileDownLoadUrl = file.fileDownloadUrl;
                        servcWorkImg.fileMd5 = file.fileMd5;
                        servcWorkImg.desc = file.fileName;
                        servcWorkImg.ts = self.randomNumber();
                        servcWorkImg.type = 1;
                        servcWorkImg.add = true;
                        servcWorkImg.checked = false;
                        servcWorkImgList.prepend(servcWorkImg);
                    }
                    self.servcWorkImgList = Utils.merge([], servcWorkImgList);
                } else {
                    MsgBox.warning(result.message);
                }
            },
            randomNumber() {
                return new Date().format("yyyyMMddHHmmss");
            },
            deleteFile: function (index) {
                this.servcWorkImgList.removeAt(index.trackKey);
                return false;
            },
            getFileName(fileName, ts){
                if (fileName != null) {
                    return fileName + "_" + ts;
                } else {
                    return ts;
                }
            },
            changeDesc: function (index) {
                let servcWorkImgList = this.servcWorkImgList;
                let servcWorkImg = servcWorkImgList[index];
                if (servcWorkImg.desc.length > 50) {
                    MsgBox.warning("文件名称不可多于50个字");
                    return;
                }
            },
            selectCheck: function (index) {
                let indexList = this.indexList || [];
                if (indexList.indexOf(index) >= 0) {
                    indexList.slice(index, 1);
                } else {
                    indexList.push(index);
                }
                let servcWorkImgList = this.servcWorkImgList;
                servcWorkImgList.forEach(function (item) {
                    item.checked = false;
                });
                indexList.forEach(function (index) {
                    let servcWorkImg = servcWorkImgList[index];
                    servcWorkImg.checked = true;
                });
                this.servcWorkImgList = Utils.merge([], servcWorkImgList);
                this.indexList = Utils.merge([], indexList);
            },
            setTag: function (event, index) {
                this.showPopoverRef(event);
                this.index = index;
                let servcWorkImgList = this.servcWorkImgList;
                this.tagName = servcWorkImgList[index].tagName;
            },
            setAttTag: function (event) {
                let servcWorkImgList = this.servcWorkImgList;
                let ids = [];
                servcWorkImgList.forEach(function (item) {
                    if (item.checked) {
                        ids.push(item.id);
                    }
                });
                if (ids.length <= 0) {
                    MsgBox.warning("请选择附件信息");
                    let popoverRef = this.$refs.attPopoverRef;
                    if (popoverRef != null) {
                        popoverRef.doClear();
                    }
                    return;
                }
                this.showPopoverRef(event);
            },
            showPopoverRef: function (event) {
                let curBtn = event.currentTarget;
                //
                let popoverRef = this.$refs.attPopoverRef;
                popoverRef.bindToReferer(
                    curBtn, 'click', {
                        showNow: true,
                        placement: 'bottom-start'
                    }
                )
            },
            doAttTagConfirm: function (data) {
                let self = this;
                let popoverRef = self.$refs.attPopoverRef;
                console.log(data);
                popoverRef.doClear();
                let servcWorkImgList = self.servcWorkImgList;
                if (!Utils.isNoB(self.index)) {
                    let servcWorkImg = servcWorkImgList[self.index];
                    let disble = servcWorkImg.disble;
                    servcWorkImg.tagName = data;
                    if (!Utils.isTrue(disble)) {
                        servcWorkImg.desc = data;
                    }
                } else {
                    servcWorkImgList.forEach(function (item) {
                        if (Utils.isTrue(item.checked)) {
                            item.tagName = data;
                            if (!Utils.isTrue(item.disble)) {
                                item.desc = data;
                            }
                            item.checked = false;
                        }
                    })
                }
                self.servcWorkImgList = Utils.merge([], servcWorkImgList);
                self.indexList = [];
                self.index = null;
            },
            doAttTagCancel: function () {
                let popoverRef = this.$refs.attPopoverRef;
                popoverRef.doHide();
            },
            removeCancel: function (index) {
                let servcWorkImgList = this.servcWorkImgList;
                let servcWorkImg = servcWorkImgList[index];
                servcWorkImg.tagName = null;
                servcWorkImg.tagFlag = false;
                this.servcWorkImgList = Utils.merge([], servcWorkImgList);
            },
            getDlgResult: function () {
                // 提供回调函数，返回结果
                let self = this;
                let result = {};
                let servcWorkImgList = self.servcWorkImgList || [];
                if (servcWorkImgList.length <= 0) {
                    result.message = "请上传附件信息";
                    result.type = "warn";
                    return result;
                }
                let descLengFlag = false;
                for (let i = 0; i < servcWorkImgList.length; i++) {
                    let servcWorkImg = servcWorkImgList[i];
                    if (servcWorkImg.desc.length > 50) {
                        descLengFlag = true;
                        break;
                    }
                }
                if (descLengFlag) {
                    result.message = "文件名称不可多于50个字";
                    result.type = "warn";
                } else {
                    for (let i = 0; i < servcWorkImgList.length; i++) {
                        let servcWorkImg = servcWorkImgList[i];
                        servcWorkImg.desc = self.getFileName(servcWorkImg.desc, servcWorkImg.ts);
                    }
                    result.data = servcWorkImgList;
                    result.type = "info";
                }

                return result;
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/workVoucher/ServcWorkVoucherImgSave.vue